import { useCommanData } from "../../contexts/commanData.context";

type ImageProps = {
  src?: string;
  alt: string;
  key?: string | number;
  className?: string;
  onClick?: () => void;
  onError?: (e: any) => void;
  ref?: any;
  width?: number;
  height?: number;
  addBaseLink?: boolean;
  onWheel?: (data: any) => void;
  style?: any;
};

export default function Image({
  src,
  className,
  onClick = () => {},
  onError = () => {},
  width = 150,
  height = 150,
  alt,
  key,
  addBaseLink = true,
  ref,
  onWheel,
  style,
}: ImageProps) {
  const { API_LINK } = useCommanData();

  return (
    <img
      onClick={onClick}
      onError={onError}
      onWheel={onWheel}
      key={key}
      className={className ? className : undefined}
      src={`${!src || src.length === 0 ? "" : addBaseLink ? `${API_LINK}${src}` : `${src}`}`}
      width={width}
      height={height}
      alt={alt}
      ref={ref}
      draggable={false}
      style={style}
    />
  );
}
